import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const attendContactAbsencesSelector = createSelector(
  (state: RootState) => state.attendContact.attendContactAbsenceList,
  (attendContactAbsenceList) => attendContactAbsenceList,
);

export const isInitAbsenceSelector = createSelector(
  (state: RootState) => state.attendContact,
  (item) => item.nextTokenAbsence !== null,
);

export const attendContactLatesSelector = createSelector(
  (state: RootState) => state.attendContact.attendContactLateList,
  (attendContactLateList) => attendContactLateList,
);

export const isInitLateSelector = createSelector(
  (state: RootState) => state.attendContact,
  (item) => item.nextTokenLate !== null,
);

export const attendContactLeaveEarlysSelector = createSelector(
  (state: RootState) => state.attendContact.attendContactLeaveEarlyList,
  (attendContactLeaveEarlyList) => attendContactLeaveEarlyList,
);

export const isInitLeaveEarlySelector = createSelector(
  (state: RootState) => state.attendContact,
  (item) => item.nextTokenLeaveEarly !== null,
);
